const LOAD_DATA_COMPANY           = 'LOAD_DATA_COMPANY'
const LOAD_DATA_COMPANY_SUCCESS   = 'LOAD_DATA_COMPANY_SUCCESS'
const LOAD_DATA_COMPANY_FAILED    = 'LOAD_DATA_COMPANY_FAILED'
const UNMOUNT_DATA_COMPANY        = 'UNMOUNT_DATA_COMPANY'
const initialState = {
  loading: true,
  data: null,
  message: null,
}
const companyReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_COMPANY:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_COMPANY_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_COMPANY_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_COMPANY:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}
export default companyReducer;